module.exports = __webpack_public_path__ + "static/media/12.1751f2c8.svg";